
const digest = '1a56aeaa7bf025e9249c2312665ec9793b6c201319537021d68f2f49913d9784';
const classes = {"wrapper":"_wrapper_1vagb_1"};
const css = `._wrapper_1vagb_1 {
  width: 100%;
  position: absolute;
  height: 100%;
  display: flex;
  align-items: center;
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  top: 0;
  left: 0;
  z-index: 10;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  